import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { handleSideBar } from '../Generic/actions/genericActions';
import Toolbar from '@mui/material/Toolbar';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
// import CssBaseline from '@mui/material/CssBaseline';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Slide from '@mui/material/Slide';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import CATALOGUES from '../../catalogues';
import Notifications from '../Generic/Notifications';
import { getTranslate } from 'react-localize-redux';
import { Alert, ListItem, ListItemAvatar, ListItemText, Stack } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import PersonIcon from '@mui/icons-material/Person';
import { Tooltip } from '@mui/material';
import withMediaQuery from '../withMediaQuery';

function HideOnScroll(props) {
	const { children, window } = props;

	// Note that you normally won't need to set the window ref as useScrollTrigger
	// will default to window.
	// This is only being set here because the demo is in an iframe.
	const trigger = useScrollTrigger({
		target: window ? window() : undefined,
	});

	return (
		<Slide appear={false} direction="down" in={!trigger}>
			{children}
		</Slide>
	);
}

HideOnScroll.propTypes = {
	children: PropTypes.element.isRequired,
	/**
	 * Injected by the documentation to work in an iframe.
	 * You won't need it on your project.
	 */
	window: PropTypes.func,
};

export const NavBar = ({ push, handleSideBar, ...props }) => {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [notificationsAnchorEl, setNotificationsAnchorEl] = React.useState(null);

	const isMenuOpen = Boolean(anchorEl);

	const isNotificationsMenuOpen = Boolean(notificationsAnchorEl);

	function handleNotificationsMenuClose() {
		setNotificationsAnchorEl(null);
	}

	function handleNotificationsMenuOpen(event) {
		setNotificationsAnchorEl(event.currentTarget);
	}

	return (
		props.client && (
			<React.Fragment>
				<HideOnScroll {...props}>
					<AppBar
						className="generic-navbar-main"
						sx={{
							...(props.side_bar?.drawer_props?.variant === 'permanent' && { zIndex: (theme) => theme.zIndex.drawer + 1 }),
						}}
					>
						<Container maxWidth={false}>
							<Toolbar disableGutters sx={{ padding: 1, display: 'flex' }}>
								<Stack
									direction={'row'}
									sx={{
										display: 'flex',
										width: '100%',
										justifyContent: 'space-between',
										alignItems: 'center',
									}}
								>
									<Box sx={{ maxWidth: '50%', display: 'flex' }}>
										<img
											src={
												props.client.logo &&
												props.client.logo.length > 0 &&
												props.config.apihost + '/auth/clients/' + props.client.id + '/files/' + props.client.logo[0].uuid
											}
											srcSet={
												props.client.logo &&
												props.client.logo.length > 0 &&
												props.config.apihost + '/auth/clients/' + props.client.id + '/files/' + props.client.logo[0].uuid
											}
											alt={props.client.logo && props.client.logo.length > 0 && props.client.logo[0].uuid}
											loading="lazy"
											// height={'50px'}
											onClick={() => push(props.whoami.redirect_url ? props.whoami.redirect_url : '/dashboard')}
											// style={{ cursor: 'pointer' }}
											style={{
												cursor: 'pointer',
												maxHeight: '50px',
												width: '100%',
												height: 'auto',
												objectFit: 'scale-down',
											}}
										/>
									</Box>
									{/* <Box sx={{ flexGrow: 1 }} /> */}
									<Box sx={{ display: 'flex' }}>
										<Stack
											direction={'row'}
											sx={{
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
											}}
										>
											<Box sx={{ display: 'flex', alignItems: 'center' }}>
												<ListItem
													alignItems="flex-start"
													sx={{
														padding: '0',
														marginRight: (theme) =>
															['sm', 'md', 'lg', 'xl'].includes(props.width) ? theme.spacing(2) : '0px',
													}}
												>
													<Tooltip
														disableHoverListener={['sm', 'md', 'lg', 'xl'].includes(props.width)}
														title={
															<Box>
																<Typography color={'inherit'} variant="body1">
																	{props.whoami.name}
																</Typography>
																<Typography color={'inherit'} component="p" variant="body2">
																	{props.client.name}
																</Typography>
															</Box>
														}
													>
														{(props.whoami.profile_photo || !['sm', 'md', 'lg', 'xl'].includes(props.width)) && (
															<ListItemAvatar
																sx={
																	!['sm', 'md', 'lg', 'xl'].includes(props.width) && {
																		marginTop: '0',
																		justifyItems: 'end',
																	}
																}
															>
																<Avatar
																	sizes="small"
																	alt={props.whoami.name}
																	src={`${props.config.apihost}/auth/users/${props.whoami.id}/files/${props.whoami.profile_photo.uuid}`}
																/>
															</ListItemAvatar>
														)}
													</Tooltip>
													{['sm', 'md', 'lg', 'xl'].includes(props.width) && (
														<ListItemText
															sx={{ margin: '0' }}
															primaryTypographyProps={{
																sx: {
																	color: props.settings.styling.navbar_background_contrast_color + ' !important',
																},
															}}
															primary={props.whoami.name}
															secondary={
																<React.Fragment>
																	<Typography
																		component="span"
																		variant="body1"
																		sx={{
																			color:
																				props.settings.styling.navbar_background_contrast_color +
																				' !important',
																			display: 'inline',
                                      fontWeight: 'bold',
																		}}
																	>
																		{props.client.name}
																	</Typography>
																</React.Fragment>
															}
														/>
													)}
												</ListItem>
											</Box>
											{props.whoami.scopes.includes('websocket.user.notifications') && (
												<Box sx={{ display: { xs: 'flex' } }}>
													<Notifications
														menuId={'notifications-bell'}
														isMenuOpen={isNotificationsMenuOpen}
														anchorEl={notificationsAnchorEl}
														handleMenuOpen={handleNotificationsMenuOpen}
														handleMenuClose={handleNotificationsMenuClose}
														translate={props.translate}
													/>
												</Box>
											)}
											<Box sx={{ display: { xs: 'flex' } }}>
												<IconButton
													size="large"
													edge="end"
													color="inherit"
													aria-label="account of current user"
													aria-haspopup="true"
													onClick={() => {
														handleSideBar(
															true,
															props.layouts && props.layouts.navbar_sidebar
																? CATALOGUES[props.layouts.navbar_sidebar.toUpperCase()]
																: CATALOGUES.NAVIGATION
														);
													}}
												>
													<MenuIcon />
												</IconButton>
											</Box>
										</Stack>
									</Box>
								</Stack>
							</Toolbar>
						</Container>
						{props.persistent_alert.open && (
							<Alert
								severity={props.persistent_alert.severity}
								{...{ action: props.persistent_alert.action }}
								{...(props.persistent_alert.icon && { icon: props.persistent_alert.icon })}
							>
								{props.persistent_alert.message}
							</Alert>
						)}
					</AppBar>
				</HideOnScroll>
				<Toolbar />
				{props.persistent_alert.open && <Alert sx={{ visibility: 'hidden' }} />}
			</React.Fragment>
		)
	);
};

NavBar.propTypes = {
	config: PropTypes.object.isRequired,
	client: PropTypes.object,
	whoami: PropTypes.object,
};

const mapStateToProps = (state) => ({
	config: state.config,
	settings: state.settings,
	client: state.login.client ?? null,
	whoami: state.users.whoami,
	translate: getTranslate(state.localize),
	persistent_alert: state.generic.persistent_alert,
	layouts: state.generic.layouts,
	side_bar: state.generic.side_bar,
});

const mapDispatchToProps = {
	push,
	handleSideBar,
};

export default connect(mapStateToProps, mapDispatchToProps)(withMediaQuery()(NavBar));
